export default __webpack_public_path__ + "static/media/play.6b9dd214.png";